import React from 'react'
import { Box, Tooltip } from '@mui/material'
import { makeStyles } from 'tss-react/mui'
import { HoverText } from '../../types/heroTextSection'

interface HoverTextComponentProps {
  item: HoverText
}

export const HoverTextComponent: React.FC<HoverTextComponentProps> = ({
  item,
}) => {
  const { classes } = useStyles()

  return (
    <Box component="div" display="inline" className={classes.position}>
      <Tooltip title={item.hoverText} classes={{ tooltip: classes.hoverText }}>
        <span className={classes.inlineText}>{item.inlineText}</span>
      </Tooltip>
    </Box>
  )
}

const useStyles = makeStyles()((theme) => ({
  position: {
    position: 'relative',
  },
  inlineText: {
    whiteSpace: 'nowrap',
    textDecoration: 'underline',
    textDecorationColor: theme.palette.action.hover,
    textDecorationThickness: theme.shape.borderRadius,
    '&:hover': {
      color: theme.palette.action.hover,
    },
  },
  hoverText: {
    marginTop: '.21875rem',
    fontSize: '1rem',
    lineHeight: '1.4375',
    fontWeight: 'normal',
    padding: '1rem 1.5rem',
    width: '20.25rem',
    borderRadius: theme.shape.borderRadius,
    color: 'white',
    backgroundColor: theme.palette.action.hover,
  },
}))

export default HoverTextComponent
